import styled, { css } from 'styled-components'

export const StyledParametersList = styled.div`
    position: absolute;
    top: 26px;
    left: -155px;
    border-radius: 0;
    background: var(--gray-0);

    margin-top: 2px;
    border: 1px solid var(--gray-400);
    border-radius: 0;
    box-shadow: 0 0 5px 0 rgba(96,105,128,.25);
    z-index: 100;

    button.btn.btn-primary {
        margin: 0px 4px;
        width: 54px;
    }

    .runs-titles {
        margin: 6px 0px 8px 8px;
    }
    .runs-list span {
        margin-left: 4px;
    }

    h3 {
        padding: 10px 0px 0px 8px;
    }

    .date-picker-run-parameters{
        min-width: 88px;
        margin-right: 12px;
    }

    li.date-picker-item{
        display: flex;
        justify-content: space-between;
        .input-group-addon.input-group-addon-right{
            left: calc(100% - 24px);
            width: unset;
            padding: 6px 2px;
        }
        div{
            flex-grow: 1;
        }
        div.input-group{
            width: calc(100% - 12px);
        }
        input.time-input{
            width: 100%;
            text-align: center;
        }
    }

    ${props =>
        props.pluginHeaderNavigationDetected &&
        css`
            top: 32px;
            left: -5px;
            z-index: 10000;
        `}

    ul {
        margin-top: 10px;
        margin-bottom: 5px;

        li {
            display: block;
            margin: 0px 0px 18px;

            ${props =>
        props.dark &&
        css`
                    label {
                        color: #fff;
                    }
                    input {
                        color: #fff;
                        background-color: #1b273e;
                        box-shadow: none;
                        border: none;
                    }
                `}
        }
    }
    /* ANNOTATIONS */

    /* Style the tab */
    .tab {
        overflow: hidden;
        border: 1px solid #ccc;
        background-color: #f1f1f1;
    }

    /* Style the buttons inside the tab */
    .tab button {
        background-color: inherit;
        float: left;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 14px 16px;
        transition: 0.3s;
        font-size: 17px;
    }

    /* Change background color of buttons on hover */
    .tab button:hover {
        background-color: #ddd;
    }

    /* Create an active/current tablink class */
    .tab button.active {
        background-color: #ccc;
    }

    .header {
        background-color: var(--gray-900);
        padding: 7px 8px;
        position: relative;
        z-index: 2;
        color: var(--gray-0);
        text-align: center;
    }

    // Annotation history

    .parameters-main {
        display: flex;
        min-height: 300px;
        max-height: 600px;
        min-width: 300px;

        .paramters-header {
            height: 50px;
            border-bottom: solid 1px lightgray;
            padding: 4px;
        }

        .parameters-right-pane {
            border-left: 1px solid lightgray;
        }

        .parameters-history {
            height: calc(100% - 50px);
        }

        .toggle-history-button {
            position: absolute;
            left: 217px;
            top: 15px;
        }

        h3 {
            color: var(--auxiliar-tipography);
            font-family: var(--font-semibold);
            font-size: 14px;
            line-height: 20px;
        }

        .parameters-list {
            padding: 0px 15px 15px 20px;
            overflow-y: auto;
            width: 300px;

            ${props => props.hasFooter ?
                css`
                        height: calc(100% - 96px);
                    `:
                css`
                        height: 100%;
                `}

            .form-group, {
                marging-bottom: 0px !important;
            }
            .edit-item {
                .check-item-info {
                    margin: 0px 10px;
                }
            }

            input[disabled] {
                color: var(--text-color)
            }
        }

        .history-tab,
        .parameters-list {
            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
                margin: 0 1px;
            }

            &::-webkit-scrollbar-track {
                background: var(--gray-100);
            }

            &::-webkit-scrollbar-thumb {
                background: var(--gray-400);
                border-radius: 8px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: var(--gray-500);
            }
        }

        .history-tab {
            overflow-wrap: break-word;
            padding: 11px 15px;
            height: 100%;
            overflow-y: auto;
            max-width: 600px;
            min-width: 200px;

            .active-annotation {
                border: 2px solid var(--blue-500);
                box-sizing: border-box;
                background-color: var(--blue-200);
                &:hover {
                    border: 2px solid var(--blue-500);
                }
            }

            .no-annotations {
                height: calc(100% - 30px);
                width: 100%;
                display: flex;
                flex-flow: column;
                justify-content: center;
                text-align: center;
                i {
                    color: var(--gray-500);
                    font-size: 24px;
                }
                span {
                    color: var(--auxiliar-tipography);
                    font-size: 13px;
                }
            }

            .live-annotation__note-time {
                line-height: 16px;
            }

            .actions-table {
                margin: 10px 0px 5px;
                white-space: nowrap;
                text-align: center;

                .fa-trash-alt:hover {
                    color: var(--text-danger);
                    cursor: pointer;
                }

                td {
                    padding: 5px 0px !important;
                }
                tr {
                    border-bottom: 1px solid var(--gray-400);
                }
                th {
                    padding: 0px 16px 5px 0px;
                    text-align: center;
                }
                tbody {
                    tr {
                        cursor: pointer;
                    }
                    
                    .remove-annotation {
                        padding-left: 60px;
                        i {
                            cursor: pointer;
                        }
                    }
                }
            }

            .history-table {
                margin: 10px 0px 5px;
                white-space: nowrap;
                text-align: center;
                td {
                    padding: 5px 15px !important;
                }
                tr {
                    border-bottom: 1px solid var(--gray-400);
                }
                th {
                    padding: 0px 16px 5px 0px;
                    text-align: center;
                }
                tbody {
                    tr {
                        cursor: pointer;
                        &:hover {
                            background-color: var(--blue-200);
                            z-index: 10;
                        }
                        .active-annotation {
                            border: 2px solid var(--blue-500);
                            box-sizing: border-box;
                            background-color: var(--blue-200);
                            &:hover {
                                border: 1px solid var(--blue-500);
                                box-sizing: border-box;
                            }
                        }
                    }
                    .row-values {
                        cursor: pointer;
                        font-size: 12px;
                        line-height: 16px;
                        padding: 7px 55px 7px 0px;
                    }
                    .remove-annotation {
                        padding-left: 60px;
                        i {
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
`
